/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui';



/* ++++++++++ --------------- CHART REPORT SECTION : STYLES --------------- ++++++++++ */
export default {
	chartreportsection: {
		width: '100%',
		minHeight: '481px',
		height: '100%',
		background: themeV2.color.base.white,
    '&.showNote-true': {
      '& .chartlegend': {
        marginTop: pxToEm(32)
      }
    },
		'& .data': {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			width: '100%',
			// '& .linkcontrols': {
			// 	flexWrap: 'wrap',
			// 	justifyContent: 'center',
			// 	margin: pxToEm(24)
			// }
			'& .percent': {
				width: 'initial !important',
				padding: `${pxToEm(4)} ${pxToEm(8)}`
			},
			'& .chartsection': {
				display: 'flex',
				width: '100%',
				marginBottom: pxToEm(24),
                flexWrap: 'wrap',
                '& .nodata': {
                    height: pxToEm(400)
                },
                '& .chartloading': {
                    height: pxToEm(410),
                    position: 'relative'
                },
                '& .loadercontainer': {
                    height: pxToEm(400),
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                },
				'& > .chart': {
                    width: 'calc(100% - 265px)'
				},
				'& .title': {
					color: themeV2.color.base.gray.dark,
					fontSize: pxToEm(16),
					paddingRight: pxToEm(24),
					minHeight: pxToEm(24)
				},
				'& > .legend': {
                    width: '100%',
                    maxWidth: '240px',
					marginRight: pxToEm(24),
					marginTop: pxToEm(24),
                    '& > .title': {
						height: pxToEm(96),
                    }
				},
				'& .legend-items': {
					maxHeight: pxToEm(500),
					overflowY: 'auto'
				},
				'& .group': {
					display: 'flex',
					alignItems: 'center',
					height: pxToEm(40),
					'& .button': {
						background: themeV2.color.base.white,
						fontSize: pxToEm(16),
						fontWeight: 500,
						width: pxToEm(180),
						'&:hover': {
							filter: 'none'
						},
						'& .icon': {
							'& > .fas': {
								fontSize: pxToEm(16)
							}
						}
					},
					'& .linkcontrols': {
						width: '60%'
					}
				}
			}
		},
    '& .name-reportnote': {
      width: '93%',
      margin: pxToEm(16)
    }
	},
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [`@media only screen and (min-width:${pxToEm(0)})  and (max-width:${pxToEm(1024)})`]: {
        chartreportsection: {
            '& .title': {
                marginBottom: `${pxToEm(16)} !important`,
				height: `inherit !important`,
            },
            '& .chart': {
                width: '100% !important'
            },
            '& .legend': {
                maxWidth: '100% !important',
                margin: pxToEm(16),
                '& .details': {
                    width: '100%'
                }
            }
        }
    },

    [`@media only screen and (min-width:${pxToEm(1025)}) and (max-width:${pxToEm(1366)})`]: {
        chartreportsection: {
            '& .chart': {
                width: 'calc(100% - 205px) !important'
            },
            '& .legend': {
                width: '180px !important'
            }
        }
    },
};